<!--
  MockDataBanner.

  Reusable "DEMO DATA" notice rendered at the top of any page or panel that
  is showing mock / example data. Used by every SuperAdmin Phase 3 surface
  whose backing endpoint has not yet shipped.

  Removing every <MockDataBanner /> usage in the SA pages is the visual
  cue for the follow-on PR sweep that lands real endpoints -- once the
  banner is gone, the page is on live data.

  Pass `surface` to name the specific frame in the banner copy.

  ASCII-only. data-testid="mock-data-banner".
-->
<template>
    <div class="mock-data-banner" role="status" data-testid="mock-data-banner">
        <span class="mock-data-banner__pill">DEMO DATA</span>
        <span class="mock-data-banner__msg">
            {{ surface }} is showing example data for design preview. Live data
            ships in a follow-on PR.
        </span>
    </div>
</template>

<script>
export default {
    name: "MockDataBanner",
    props: {
        surface: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.mock-data-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    margin-bottom: 16px;
    background: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 4px;
    color: #78350f;
    font-size: 13px;
}
.mock-data-banner__pill {
    background: #f59e0b;
    color: #fff;
    font-weight: 600;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 3px;
    letter-spacing: 0.05em;
}
.mock-data-banner__msg {
    line-height: 1.4;
}
</style>
